import React from "react";
import PropTypes from "prop-types";
import { GridColumn, GridContainer, GridRow } from "arv-reactcomponents";
import { OrderConfirmation } from "npmlinks-constants";
import { ToCurrency } from "../../../utils";

const { ORDERCONFIRMPAGE } = OrderConfirmation;

const OrderDataBlock = props => {
  const { orderLevelDetails, total } = props;
  return (
    <GridContainer className="nw-orderconfirm-orderdatablock">
      <GridRow className="nw-orderconfirm-orderdatablock-row">
        <GridColumn className="nwc-grid-col-xs-6">
          <div className="nw-orderconfirm-orderdatablock-col-key">
            {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.ORDER_ID}
          </div>
          <div>{orderLevelDetails.orderId}</div>
        </GridColumn>
        <GridColumn className="nwc-grid-col-xs-6">
          <div className="nw-orderconfirm-orderdatablock-col-key">
            {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.DATE_PLACED}
          </div>
          <div>{orderLevelDetails.orderDate}</div>
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-orderdatablock-row">
        <GridColumn className="nwc-grid-col-xs-6">
          <div className="nw-orderconfirm-orderdatablock-col-key">
            {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.ORDER_TOTAL}
          </div>
          <div>{ToCurrency(total)}</div>
        </GridColumn>
        <GridColumn className="nwc-grid-col-xs-6">
          <div className="nw-orderconfirm-orderdatablock-col-key">
            {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.PAYMENT_TYPE}
          </div>
          <div>{orderLevelDetails.paymentType}</div>
        </GridColumn>
      </GridRow>
      <GridRow className="nw-orderconfirm-orderdatablock-row">
        <GridColumn className="nwc-grid-col-xs-6">
          <div className="nw-orderconfirm-orderdatablock-col-key">
            {ORDERCONFIRMPAGE.ORDER_SUMMARY_BLOCK.TOTAL_QTY}
          </div>
          <div>{orderLevelDetails.totalQty}</div>
        </GridColumn>
      </GridRow>
    </GridContainer>
  );
};

OrderDataBlock.propTypes = {
  orderLevelDetails: PropTypes.shape({}).isRequired,
  total: PropTypes.number.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: OrderDataBlock,
  component: OrderDataBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/OrderDataBlock/index.js